<template>
  <Vueform
    :key="initialDateOfBirth"
    class="w-full"
    :float-placeholders="false"
    :display-errors="false"
    :force-labels="false"
    :display-messages="false"
    v-model="formData"
    @change="handleFormData"
  >
    <div class="col-span-12">
      <DateElement
        name="dateOfBirth"
        label="Date of Birth"
        :placeholder="dobPlaceholderText"
        :default="initialDateOfBirth"
        :disabled="disabled"
        :max="new Date()"
        display-format="DD-MM-YYYY"
        :rules="['required', `regex:^\\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\\d|3[01])$`]"
        :messages="{
          required: 'Required',
          regex: `Enter a valid date`,
        }"
        :add-classes="{
          DateElement: {
            inputContainer: 'mt-[8px] md:mt-[12px] lg:mt-[16px]',
          },
          ElementLabel: {
            container:
              'text-[0.875rem] md:text-[1.5rem] lg:text-[1.625rem] leading-[1.25rem] md:leading-[2rem] lg:leading-[2.125rem] font-semibold text-[#191817]',
          },
        }"
      />
    </div>
  </Vueform>
</template>
<script>
export default {
  data() {
    return {
      formData: {
        dateOfBirth: null,
      },
    };
  },
  computed: {
    initialDateOfBirth() {
      return this.originalPayload?.dateOfBirth || null;
    },
  },
  props: {
    originalPayload: {
      type: Object,
      default: () => ({}),
    },
    dobPlaceholderText: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    originalPayload: {
      handler(newVal) {
        if (newVal?.dateOfBirth && this.formData.dateOfBirth !== newVal.dateOfBirth) {
          this.formData.dateOfBirth = newVal.dateOfBirth;
          this.$nextTick(() => {
            this.$emit('handle-form-data', this.formData.dateOfBirth);
          });
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    if (this.originalPayload?.dateOfBirth) {
      this.formData.dateOfBirth = this.originalPayload.dateOfBirth;
      this.$nextTick(() => {
        this.$emit('handle-form-data', this.formData.dateOfBirth);
      });
    }
  },
  methods: {
    handleFormData() {
      this.$emit('handle-form-data', this.formData.dateOfBirth);
    },
  },
};
</script>

<style scoped>
:deep(.form-input-group) {
  background-color: #ffffff !important;
  border: 1px solid #c3c2c1 !important;
  border-radius: 8px !important;
  min-height: unset !important;
}

:deep(.form-bg-disabled.form-input-group) {
  background-color: #f0f2f4 !important;
  border-color: #d3d8de !important;
  cursor: not-allowed !important;
}

:deep(.flatpickr-wrapper input) {
  height: auto !important;
  padding: 16px !important;
  color: #21201e;
  font-size: 16px;
  line-height: 24px;
}

@media (min-width: 768px) {
  :deep(.flatpickr-wrapper input) {
    font-size: 28px;
    line-height: 38px;
  }
}

@media (min-width: 1024px) {
  :deep(.flatpickr-wrapper input) {
    font-size: 30px;
    line-height: 40px;
  }
}

:deep(.flatpickr-wrapper input:disabled) {
  background-color: #f0f2f4 !important;
  color: #9ca3af !important;
  cursor: not-allowed !important;
}
</style>
